module.exports = __webpack_public_path__ + "img/student_8.ce3373a2.png";